export default {
    ding_app_name: 'DING 訂管家',
    message: {
        items_automatically_added_to_cart: '已將以下項目自動加入購物車：<br>{items}',
        please_select_booking_date_time_to_calculate: '選擇預約時間後更新金額',
        login_phone_placeholder: '輸入手機號碼以繼續',
        you_have_logged_in_welcome: '已登入，歡迎您',
        sms_not_verified: '驗證失敗',
        gray_out_means_not_available: '灰色即代表無法預約',
        fail_to_get_order: '無法取得訂單詳細資料',
        please_select_custom_first: "請先選擇{custom}",
        please_select_end_date_first: "請先選擇結束時間",
        sorry_copy_failed: '抱歉，無法在您的瀏覽器進行複製，需請您手動複製。',
        atm_reported: '(已回報)',
        please_login_to_proceed_booking: '請您登入或註冊來完成預約',
        are_you_sure_to_delete_image: "確定要刪除選項圖片？",
        cart_payment_method: "付款方式",
        sorry_fail_to_check_bookings: '抱歉，目前無法檢查預約與休假狀況',
        min_n_items_required: "最少需買 {n} 件商品",
        max_n_items_exceeded: "最多不得超過 {n} 件商品",
        cart_logistic: "配送方式",
        please_select_items: "請選擇購買項目",
        cart: "結帳項目",
        is_preview_cant_book: "目前服務尚未開放預約，請持續關注",
        is_preview_cant_book_with_schedule: "服務尚未開放預約，將於 {start} 開放預約",
        please_select_service: "請於上方選擇服務項目",
        please_select_service_to_start: '選擇服務項目開始預約',
        please_select_service_to_start_custom: '選擇{custom}開始預約',
        code_expired_at: "驗證碼將於 {expiredAt} 過期",
        wrong_sms_code: '驗證碼錯誤，請正確輸入驗證碼',
        select_start_time: '選擇開始時間',
        done: '完成',
        saving: '儲存中...',
        uploading: '儲存中...',
        deleting: '刪除中...',
        edit: '修改',
        add_images: '新增圖片',
        delete: '刪除',
        delete_block: '刪除此塊',
        are_you_sure_to_delete: '您確定要刪除嗎？',
        add_album_to_portfolio: '新增相簿',
        max_images_per_album_reached: '單本相簿最多只能有 {maxPhotoCount} 張照片。',
        edit_album: '編輯相簿',
        new_album: '新的相簿',
        set_as_cover: '設為封面',
        is_current_cover: '目前封面',
        enter_address: '請輸入地址來定位',
        enter_youtube_link: '請輸入 Youtube 影片網址',
        add_user_review: '新增顧客評價',
        set_customer_avatar: '設定顧客大頭照',
        toggle_image_position: '切換照片位置',
        select_image: '選擇照片',
        crop_the_image: '裁切照片',
        photos: '張照片',
        add_recommendation: '新增推薦廠商 ',
        add_option: '新增選項',
        option_text: '選項文字',
        set_image: '設定圖片',
        delete_question: '刪除此問題',
        open_album: '瀏覽',
        more_albums: '更多作品',
        album_image_limit: '單本相簿上限 {maxPhotoCount} 張照片',
        album_image_unit: '張',
        collapse_albums: '收合',
        close: '關閉',
        top_banner: '上方大橫幅',
        slogan_title: '大標題',
        slogan_title_placeholder: '點此輸入您的品牌精神/服務口號/標語...等',
        slogan_subtitle: '副標題',
        slogan_subtitle_placeholder: '點此輸入副標題',
        weekday_1: '週一',
        weekday_2: '週二',
        weekday_3: '週三',
        weekday_4: '週四',
        weekday_5: '週五',
        weekday_6: '週六',
        weekday_7: '週日',
        to: '至',
        save: '儲存',
        confirm: '確認',
        check_time: '查詢檔期',
        choose_service: '選擇服務項目',
        choose_member: '選擇服務人員',
        select_date: '選擇日期',
        select_start_date: '開始日期',
        select_end_date: '結束日期',
        select_member: '選擇服務人員',
        select_custom: '選擇{custom}',
        select_service_first: '請先選擇服務項目',
        no_member_for_service: '沒有可以的服務人員',
        your_basic_information: '您的基本資料',
        questions_for_booking: '預約問卷',
        name: '姓名',
        phone: '聯絡電話',
        customer_phone_placeholder: '此電話將作為聯絡用途，請正確填寫',
        submit: '送出預約',
        please_select_your_answer: '請選擇答案',
        please_fill_your_answer: '請填寫答案 ',
        please_fill_your_name: '請填寫您的姓名',
        please_fill_your_company: '請填寫您的公司名稱',
        please_fill_your_phone: '請正確填寫您的電話號碼',
        please_fill_your_email: '請填寫您的 email',
        please_fill_your_address: '請填寫您的地址',
        please_fill_your_subdomain: '請填寫您的子網域名稱',
        please_fill_your_line_id: '請填寫您的 LINE 帳號',
        please_fill_vat_number: '請填寫您的統一編號',
        please_fill_business_entity_name: '請填寫您的營業人名稱',
        email: 'Email',
        please_correct_your_email: '請正確填寫您的email',
        cant_get_availability: '暫時無法取得檔期資訊，真的很抱歉，請稍候再試。',
        select_from_following_time: '以下是可以預約的時間，請點選日期/時段繼續預約。',
        no_available_time: '此時間無法預約，請選擇其他時間',
        fail_to_book: '預約失敗，請洽管理員',
        fail_to_book_service_is_disabled: '此服務已暫停接受預約，感謝您的詢問，謝謝！',
        fail_to_book_blocked_customer: '目前無法預約',
        book_success: '預約完成，後續我們將聯絡您，謝謝',
        book_success_with_atm_info: '已送出預約要求，請依以下轉帳資訊完成轉帳方可確定您的預約。完成匯款後請至  <a href="{url}">{url}</a> 回報，謝謝！<br>總金額：${amount}<hr>{bankInfo}',
        book_payment_atm_info: "總金額：${amount}\n{bankInfo}",
        atm_info_copied: '已複製到剪貼簿',
        copy_bank_info: '複製付款資訊',
        confirm_submit_booking_normal: '是否確認您的預約？<br><br>「送出預約」後，我們將會收到您的預約，請勿重複預約。',
        confirm_submit_booking_with_online_payment: '是否確認您的預約？<br><br>「送出預約」後，我們將會收到您的預約<br><br>下一步將引導您去付款頁面，若您未完成付款，請勿再重複預約。未成功完成付款之預約可至Email內的預約信件內再次進行付款。',
        processing: '處理中',
        fail_to_upload: '上傳失敗',
        fail_to_save_content_unit: '內容儲存失敗',
        click_to_enter: '點此輸入...',
        click_to_enter_option_text: '點此輸入選項文字',
        ok: '確認',
        drag_blocks_to_here: '拖動區塊到這裡',
        click_plus_to_add_blocks_to_here: '點擊 + 按鈕來新增內容',
        now_having: '現有',
        only_image_supported: '請選擇 JPG 或 PNG 格式的圖片！',
        unsupported_files_are_skipped: ' 為不支援的檔案類型，僅支援 JPG/PNG 圖檔。',
        max_album_reached: '已達到作品集相簿數量上限',
        max_photo_reached: '已達到相簿相片張數上限',
        drag_to_change_order: '保持按壓後，拖動以調整順序',
        cover_photos: '封面底圖',
        logo_photo: 'Logo 圖片',
        service_start_time_hint: '此服務固定 {startTime} 開始',
        no_subject_entered: "請輸入信件主旨喔",
        no_body_entered: "信件內容是空的耶",
        confirm_to_save: '儲存確認',
        confirm_to_cancel: '取消確認',
        confirm_to_delete: '刪除確認 ',
        confirm_to_restore: '回復確認 ',
        add_photo: '新增照片',
        please_edit_contract_templates_on_desktop: '目前暫不提供行動裝置編輯合約內容，請使用電腦進行編輯以獲得較好體驗',
        enter_cancel_reason: '取消原因',
        subdomain_only_accepts_alpha_number_and_dash: '子網域名稱僅能輸入英文、數字與半形破折號',
        click_to_enter_note_placeholder: '點此提供給顧客的備註欄內容提示',
        deleting: '刪除中',
        please_select_datetime_to_book: '選擇預約時間',
        please_select_date: '請選擇日期',
        duplicate: '複製',
        book: '預約',
        fb_contact_customer: 'Facebook訊息通知',
        fb_contact_customer_hint: '若您擔心忘記，想收到Facebook訊息即時通知，請勾選這裡 （我們不會主動存取您的Facebook資料，僅用於系統發送預約狀態更新與溫馨提醒）',
        add_block: '新內容',
        select_block_to_add: '選擇要加入的內容種類',
        file_should_smaller_than_25_mb: '檔案上限不可超過 25MB ({fileName} 為 {size} MB)',
        files_should_smaller_than_25_mb: '檔案上限不可超過 25MB，已跳過下列檔案：{fileNames}',
        add_question: '加入項目',
        click_plus_to_add_question_to_here: '點擊 + 按鈕來新增問題/項目',
        select_question_to_add: '選擇要加入的項目',
        n_more_bookings: '還有 {n} 個',
        updated: '更新完成',
        check_question_password_title: '請輸入私密賣場密碼',
        check_question_password_label: '密碼',
        check_question_password_button: '進入賣場',
        check_question_password_warning: '請輸入密碼',
        check_question_password_fail: '密碼錯誤',
        check_question_password_fail: '密碼錯誤，跳轉回首頁',
        no_customer_found: '抱歉，找不到您的顧客資料',
        no_track_order_input: '請輸入電話以及 Email',
        landing_page_is_preparing: '網站準備中',
        preparation_hint: '主頁準備中，僅管理員可瀏覽',
        please_fill_line_id_or_line_url: '請填入 LINE 帳號或是 LINE 網址',
        row: '列',
        column: '欄',
        add_row: '新增列',
        add_column: '新增欄',
        click_to_enter_row_title: '點此輸入列名稱',
        click_to_enter_column_title: '點此輸入欄名稱',
        cart_items_all_not_available_in_this_month: '購物袋內全部商品在此月份可預約之時段均已售完。',
        reorder_hint: '請拖曳圖標來調整順序',
        sum_max_size_exceeded: '超過檔案大小上限，總和不可超過 {max}MB',
        upload_image_failed: '圖片上傳失敗，請重新上傳',
        please_verify_customer_sms: '請先驗證顧客的手機號碼',
    },
    general: {
        no_thanks: '不用了',
        share: '分享',
        item_link_copied: '商品連結已複製到您的剪貼簿',
        copy_failed: '複製失敗',
        count: '數量',
        apply: '套用',
        per_day: '每天',
        per_week: '每週',
        per_month: '每月',
        yesterday: '昨天',
        today: '今天',
        tomorrow: '明天',
        last_week: '上週',
        this_week: '本週',
        next_week: '下週',
        last_month: '前月',
        this_month: '本月',
        next_month: '下月',
        empty_description: '無',
        profile: '個人資料',
        bookings: '預約紀錄',
        setting: '設定',
        logout: '登出',
        login: '登入',
        head_to: '前往',
        required: '必填',
        optional: '選填',
        total_amount: "共",
        ge: "x{count}",
        unlimited: '不限',
        manage: '管理',
        remove_condition: '取消條件',
        day_1: '1日',
        day_2: '2日',
        day_3: '3日',
        day_n: '{n}日',
        month: "月",
        day: "日",
        until: '至',
        modify: '修改',
        edit: "編輯",
        new: '新增',
        select: '選取',
        select_all: '全選',
        cancel_select: '取消選取',
        saving: '儲存中...',
        deleting: '刪除中',
        finish: '完成',
        oops: '哎呀',
        close: '關閉',
        created_at: '建立時間',
        done: '完成',
        actions: '操作',
        cancel: '取消',
        leave: '休假',
        extra_hours: '加班',
        service_extra_hours: '加開',
        create_new: '新增',
        save: '儲存',
        update: '更新',
        delete: '刪除',
        expand: '更多',
        collapse: '收合',
        deleted_at: '刪除時間',
        confirm: '確認',
        deleted: '已刪除',
        am: '上午',
        pm: '下午',
        warning: '注意',
        to: '至',
        fail: '失敗 ',
        success: '成功',
        input_is_required: '請輸入文字',
        please_select: '請選擇',
        align_left: '靠左',
        align_right: '靠右',
        align_middle: '置中',
        no_title: '無標題',
        notice: '注意',
        go_back: '返回',
        create: '新增',
        more: '更多',
        datetime_to_booking: '預約時間',
        booking_end_datetime: '結束時間',
        hint: "提示",
        check_customer_link: '訂單連結',
        track_order: '查詢預約',
        track_order_again: '重新查詢',
        twd: '台幣 $',
        clear: '清除',
        sort: '調整順序',
        save_order: '儲存順序',
        times: '次',
        points: '點',
        no_data: '無',
        archive: '封存',
        unarchive: '已封存',
        search: '搜尋',
        unknown: '未知',
        male: '男性 (M)',
        female: '女性 (F)',
        other: '未指明或其他性別認同 (X)',
        under20: '20歲以下',
        '21-25': '21 - 25歲',
        '26-30': '26 - 30歲',
        '31-35': '31 - 35歲',
        '36-40': '36 - 40歲',
        '41-45': '41 - 45歲',
        '46-50': '46 - 50歲',
        '51-55': '51 - 55歲',
        '56-60': '56 - 60歲',
        over60: '超過60歲',
        start_date: "起始日期",
        end_date: "結束日期",
        service: '服務',
        member: '人員',
        buyable: '商品',
        preselected_buyable: '預選商品',
        datetime: '日期時間',
        color_picker: '選色器',
    },
    provider: {
        service_leave: '服務暫停',
        who_is_taking_leaves: '請假人員',
        remove_this_service_leave: '取消暫停服務之後，將開放顧客預約這個時段。',
        remove_this_member_leave: '取消休假之後，將開放顧客預約這個時段。',
        remove_this_member_extra_hours: '取消加班後，顧客將無法在原加班時間進行預約',
        remove_this_service_extra_hours: '取消加開後，顧客將無法在原加開時間進行預約',
        cancel_leave: '開放預約',
        cancel_leave_title: '確認開放服務預約？',
        cancel_extra_hours: '取消加班',
        cancel_service_extra_hours: '取消加開',
        cancel_extra_hours_title: '取消加班？',
        cancel_service_extra_hours_title: '取消服務加開？',
        cancel_member_leave_title: '取消休假？',
        leave_overlapped: '這個日期內已有排定休假，請確認後再調整休假時間 ',
        failed_to_add_leave: '發生問題，無法新增休假。',
        booking_status: '狀態',
        service: '服務項目',
        member_user: '服務人員',
        service_datetime: '服務時間',
        service_end_datetime: '服務結束時間',
        customer: '顧客',
        customer_phone: '顧客電話',
        booking_status_unapproved: '待回覆',
        booking_status_approved: '接受',
        booking_status_cancelled: '取消',
        booking_status_customer_cancelled: '顧客取消',
        booking_status_rejected: '拒絕',
        take_leave: '人員休假',
        single_day_off: '單日休假',
        multiple_day_off: '連續休假',
        day_off_mode_hint: '要加入哪一種休假？',
        leave_date: '休假日期',
        leave_start_date: '開始日',
        leave_end_date: '結束日',
        availabilities: '可預約檔期',
        files_uploading_sure_to_exit: '確定要關閉嗎？還有檔案在上傳中，關閉的話，這些檔案將不會繼續上傳。',
        booking_id: '編號',
        should_update_all_member_working_time: '成員是否可接受預約是由各個成員的工作時間決定，而非此營業時間決定！<br><br>是否要同步更新所有成員的工作時間？',
        update_all: '全部更新',
        dont_update: '不，保留原工作時間'
    },
    informationBlock: {
        contentRenderType: {
            'CONTENT_RENDER_TYPE_TEXT': '文字',
            'CONTENT_RENDER_TYPE_IMAGE': '圖片',
            'CONTENT_RENDER_TYPE_TEXT_AND_IMAGE': '單張圖文',
            'CONTENT_RENDER_TYPE_MULTIPLE_TEXT_AND_IMAGES': '多張圖文',
            'CONTENT_RENDER_TYPE_ADDRESS': '地址',
            'CONTENT_RENDER_TYPE_PORTFOLIO': '作品集',
            'CONTENT_RENDER_TYPE_USER_REVIEW': '顧客好評',
            'CONTENT_RENDER_TYPE_PROVIDER_RECOMMENDATION': '推薦廠商',
            'CONTENT_RENDER_TYPE_SERVICES': '服務項目',
            'CONTENT_RENDER_TYPE_MEMBERS': '團隊成員',
            'CONTENT_RENDER_TYPE_IG': 'Instagram',
            'CONTENT_RENDER_TYPE_BOOKABLES': '可預約項目',
            'CONTENT_RENDER_TYPE_YOUTUBE': 'Youtube 影片',
        }
    },
    question: {
        answerType: {
            'ANSWER_TYPE_SHORT_ANSWER': '短文字',
            'ANSWER_TYPE_PARAGRAPH': '長文字',
            'ANSWER_TYPE_SINGLE_CHOICE': '單選',
            'ANSWER_TYPE_MULTIPLE_CHOICE': '多選',
            'ANSWER_TYPE_MULTIPLE_CHOICE_WITH_NOTE': '多選加附註',
            'ANSWER_TYPE_INFO': '說明區塊',
            'ANSWER_TYPE_FILE_UPLOAD': '檔案上傳',
            'ANSWER_TYPE_DATE': '日期',
            'ANSWER_TYPE_SHOPPING': '加購',
            'ANSWER_TYPE_LINEAR_SCALE': '線性刻度',
            'ANSWER_TYPE_SECTION': '問題區段',
            'ANSWER_TYPE_ADDRESS': '地址',
            'ANSWER_TYPE_YOUTUBE': 'Youtube',
            'ANSWER_TYPE_SINGLE_MATRIX': '單選方格',
            'ANSWER_TYPE_MULTIPLE_MATRIX': '多選方格',
        },
        required: '必填',
        title_placeholder: '請輸入問題',
        enter_question_description: '可輸入更詳細的問題說明',
        no_options_for_this_question: '此題目還沒有設定選項，將不會出現給顧客填寫',
        insert_image: '設定問題圖片',
        info_title_placeholder: '說明區塊標題（可留空）',
        section_title_placeholder: '問題區段標題（可留空）',
        address_title_placeholder: '地址區塊標題（可留空）',
        youtube_title_placeholder: 'Youtube 區塊標題（可留空）',
        set_image: '設定圖片',
        info_text_placeholder: '更多說明',
        note: '附註'
    },
    email: {
        compose: '編輯郵件',
        subject: '主旨',
        subject_hint: '請輸入郵件主旨',
        apply_template: '套用範本',
        to: '收件人',
        body: '內文',
        send: '寄出',
        choose_from_template: '選擇範本',
        compose_template: '編輯範本',
        template_title: '範本標題',
        no_templates_yet: '還沒有範本',
        fail_to_send_mail: '發送失敗...',
        fail_to_send_mails_for_bookings: '以下預約發送失敗：\n {bookings}',
        template_saved: '已儲存範本',
        mail_sent: '通知已寄出囉',
        not_sent_successfully: '發送失敗',
        fail_to_update_email_template: '無法更新 Email 樣板',
        fail_to_create_email_template: '無法新增 Email 樣板',
        save_edited_template: '儲存修改',
        save_as_template: '儲存為新範本',
        template_delete: '刪除範本 {templateName} 嗎？',
        type: {
            'customer-booking-request': '收到預定通知',
            'customer-booking-approved': '接受預定通知',
            'customer-booking-rejected': '拒絕預定通知',
            'customer-booking-cancelled': '取消預定通知',
            'request-sign-contract': '合約簽署邀請',
            'customer-contract-signed': '已簽署合約通知',
            'customer-booking-cancelled-by-customer': '顧客取消預約通知',
            'customer-booking-reminder': '服務提醒通知',
            'customer-custom-mail': '手動發信',
            'customer-invite-file-vault': '檔案分享邀請'
        }
    },
    services: {
        form_created_and_linked_to_service_go_edit: '已建立問卷，並已連結至服務，是否前往編輯問卷？',
        accept_booking_until_day_time: '截止當日截止於',
        minimum_custom_duration: '最短預約時間',
        maximum_custom_duration: '最長預約時間',
        please_enter_longest_days_for_custom_duration: '請輸入最長顧客可選的天數',
        fixed_time_for_end: '固定結束時間',
        can_custom_duration: '可選擇預約結束時間',
        hide_duration: '不顯示服務總長',
        hide_limited_periods: '不顯示期間限定時間',
        payment_gateways: '開放付款方式',
        payment_gateways_hint: '請選擇這個服務接受的付款方式',
        payment_wait: '等候通知付款',
        payment_manual: '到店付款',
        payment_atm: '自行轉帳',
        payment_ecpay: '綠界金流',
        payment_linepay: 'LINE Pay',
        payment_tappay: 'TapPay',
        auto_approve_with_down_payment: '收到訂金自動接受預約',
        auto_request_down_payment_hint: '顧客預約後，系統自動額外發送付款要求通知，注意：使用自行轉帳與線上金流整合始可自動發送訂金。',
        auto_request_down_payment: '自動要求訂金',
        online_payment_methods_required_to_enable_auto_down_payment: '自動要求訂金功能需要至少開啟一個線上付款方式',
        down_payment_amount: '自動收訂金額',
        auto_request_payment: '由系統收取服務價格',
        time_split: '服務間隔（分鐘）',
        auto_approve: '自動接受預約',
        auto_approve_hint: '若時間許可或是該服務允許同時間多筆預約，系統將自動接受該預約<br><span class="text-warning">注意：若預約問卷內有購物袋問題時，是否自動通過，請至預約問卷內設定。</span>',
        deleted_service: '舊有服務',
        add_new_service: '增加新服務',
        select_service_icon: '請選擇服務小圖示',
        title: '服務名稱',
        title_placeholder: '點此輸入服務名稱',
        description: '服務內容',
        description_placeholder: '點此輸入該服務所提供的細節內容...',
        duration: '服務總長',
        price: '服務價格',
        price_up: '起',
        no_price: '不設定價格',
        fixed_price: '固定價格',
        range_price: '價格區間 ',
        min_price: '最低價格',
        place: '服務地點',
        place_placeholder: '點此輸入服務地點或希望會面地點（選填）',
        members: '服務人員',
        duration_format: '{hours} 小時 {minutes} 分鐘',
        duration_format_hour_only: '{hours} 小時',
        duration_format_minute_only: '{minutes} 分鐘',
        start_datetime_limited: '期間限定',
        start_datetime_limited_hint: '若有輸入限定期間，表示顧客預約此服務時僅在該段日期內可提供服務。此功能可設定像是「海外拍攝」、「講座」等有日期限定的服務項目。',
        limited_period: "期間限定 {start} 至 {end}",
        start_time_format: '{amPm} {hour}:{minute}',
        hour: '小時',
        minute: '分鐘',
        hours: '小時 ',
        minutes: '分鐘',
        hour_short: '點',
        minute_short: '分',
        am: '上午',
        pm: '下午',
        editor: {
            create: '建立服務',
            edit: '編輯服務'
        },
        fixed_start_time: '固定開始時間',
        fixed_start_time_at: '固定 {start} 開始',
        fixed_start_time_hint: '若有輸入固定時間，表示顧客預約此服務時不可隨意選擇時段，僅能預約此時間。此功能主要用於設定如「晚宴彩妝」、「上午課程」等有時間性的服務項目。',
        use_form: '使用預約問卷',
        preview_form: '預覽該問卷',
        allow_multiple_orders: '可同時間多筆預約',
        allow_multiple_orders_hint: '若啟用，此服務將允許同時間接受多筆預約，即顧客詢問之檔期已有此項服務的確認預約，仍可接受預約申請。',
        validation: {
            title_empty: '請輸入服務名稱',
            duration_empty: '請設定服務總長',
            no_members_selected: '請選取服務人員',
            start_time_not_set: '請選取開始時間',
            price_not_set: '請設定價格'
        },
        service_saved: '服務項目已儲存',
        create: '新增服務',
        delete_service: '刪除',
        confirm_delete_service: '確定要刪除此服務？',
        confirm_delete_service_text: '顧客將無法預約此服務，但您可以看到此服務過去的預約。',
        service_disabled: '不開放預約',
        service_accepting_booking: '接受預約中',
        accept_booking_from_until: '開放預約期間',
        accept_booking_unit_night: '晚',
        accept_booking_unit_day: '天',
        accept_booking_unit_minute: '分鐘',
        accept_booking_unit_hour: '小時',
        accept_booking_unit_month: '個月',
        accept_booking_unit_year: '年',
        start_accepting_booking: '前開放預約',
        stop_accepting_booking: '截止預約',
        stop_accepting_booking_earlier: '前',
        stop_accepting_booking_earlier_with_time: '前',
        disable_service: '下架',
        enable_service: '上架',
        schedule_auto_disable: '排程下架',
        schedule_auto_enable: '排程上架',
        service_is_disabled: '服務已暫時下架',
        service_is_enabled: '服務已上架',
        check_accept_booking_from: '設定開放預約時間',
        check_accept_booking_until: '設定截止預約時間',
        at_least_earlier_than: '最晚',
        at_least_later_than: '最早',
        cancellation_policy: '取消政策',
        cancellation_policy_anytime: '開始前可隨時取消',
        cancellation_policy_anytime_before_end: '結束前可隨時取消',
        cancellation_policy_no: '不可網路取消',
        cancellation_policy_before_n: '一段時間前可網路取消',
        cancellation_policy_hint: '顧客可隨時取消您尚未接受的預約。<br>已接受的預約，將依照您下面的設定來檢查是否可取消預約。',
        stop_accept_cancellation: '前接受取消',
        cancellation_text: '輸入不可取消時顯示給顧客的提示訊息。若留空，系統將預設顯示「此預約不可透過網路取消，請直接聯繫我們，謝謝。」',
        save_order: '儲存順序',
        sort: '調整順序',
        order_saved: '順序已儲存',
        max_amount_per_day_per_member: '每日每位人員最多預約上限',
        max_amount_per_day_per_customer: '每日每位人員同一位顧客最多預約上限',
        orders: '個預約',
        notify_customer_before_n_hour: '顧客提醒時間',
        hours_before_service: '服務開始前 {0} 小時提醒',
        need_premium_to_custom_reminder_time: '升級為 <b>天鵝 會員</b>即可調整通知時間。',
        custom_reminder_time_membership_hint: '天鵝會員可調整通知時間',
        limited_start_datetime_expired: '已過期',
        enable_sms_verification: '啟用顧客手機號碼驗證',
        enable_sms_verification_hint: '啟用手機驗證後，顧客需驗證手機號碼後才能送出預約要求。<br>若您的簡訊點數不足，<b>**顧客將無法進行預約**</b>，請注意您的簡訊點數是否足夠！',
        private_service: '私密賣場',
        enter_private_password: '請輸入密碼',
        private_password_label: '密碼',
        private_copy_content: '您好，請點擊以下連結進入私密預約/購買網址。',
        private_warning_text: '請設定私人賣場密碼',
        copy_private_link: '複製',
        private_link_copied: '已複製',
        private_link_error: '無法複製',
        private_service_hint: '需輸入指定密碼才能進入預約的服務項目，欲申請此功能請直接聯繫 Ding 訂管家。',
        private_service_hint_enabled: '顧客需輸入指定密碼才能進入預約的服務項目。',
        archive_service: '封存',
        already_archived_service: '已封存',
        service_is_archived: '已封存服務 {name}，服務已自動下架',
        service_is_archived_disabled_already: '已封存服務 {name}',
        service_is_unarchived: '服務 {name} 已解除封存，若需上架，請自行操作上架',
        is_preview: '服務下架時搶先看問卷',
        please_enter_service_price: '請輸入服務金額',
        please_enter_down_payment_amount: '請輸入訂金金額 (金額須大於 0)',
        points_deductable: '可用點數折抵',
        hide_start_time: '不顯示固定開始時間',
    },
    theme: {
        landing_theme: '主頁主題配色',
        background_color: '背景顏色',
        tint_color: '主題色'
    },
    booking: {
        book_again: '再次預約',
        issues_found: '發現以下問題<br>請確認是否真的要接受預約<br> {bookingInfo}',
        print: '列印',
        display_id: '預約編號',
        created_by: '由 {creatorName} 建立',
        customer: {
            name: '姓名',
            phone: '聯絡電話',
            phone_calling_code: '國碼',
            note: '備註',
            no_note: '沒有備註內容',
            email: 'Email'
        },
        mail: {
            fail_to_sent: '無法發送',
            sent: '已送出'
        },
        note: '內部備註',
        note_to_customer: '給顧客的備註',
        note_from_provider: '註記',
        email_status_report: '發信紀錄',
        created_at: '預約於',
        information: '預約詳細',
        datetime: '日期',
        customer_information: '顧客資訊',
        service_information: '預約',
        answers: '問卷回答',
        accept: '確認',
        open_detail: '查看',
        reject: '拒絕',
        brief: '將預約 {0} 由 {1} 提供的服務 {2}',
        open_email_module: '發信',
        reason_of_rejection: '拒絕原因',
        reason_of_rejection_placeholder: '輸入拒絕原因，顧客將在通知信內看到此原因',
        reason_of_rejection_placeholder_with_presets_bookings: '請注意：此為使用課卡建立的預約，其他同時使用該課卡自動建立之預約將會一起拒絕。<br><br>輸入拒絕原因，顧客將在通知信內看到此原因',
        are_you_sure_to_accept_order: '確定接受預約嗎？',
        are_you_sure_to_accept_order_with_presets: '此為使用課卡建立的預約，若有同時使用課卡自動建立的預約將一次同時設為接受。<br><br>確定接受預約嗎？',
        are_you_sure_to_cancel_this_booking: '確定取消此預約？<br>您可輸入取消原因，顧客將會在通知內看到此原因。',
        are_you_sure_to_cancel_this_booking_with_presets: '確定取消此預約？<br>若有同時使用課卡自動建立的預約將同時一起被取消。<br><br>您可輸入取消原因，顧客將會在通知內看到此原因。',
        no_approved_bookings: '沒有進行中預約',
        no_unapproved_bookings: '沒有新預約',
        no_customer_cancelled_bookings: '沒有顧客取消的預約',
        no_other_bookings: '沒有已過期或已拒絕約預約',
        has_past_no_reply: '逾期未回覆',
        warn_overlap_booking: '這個時段已有其他預約',
        booked_at: '於 {bookedAt} 預約',
        edit: '編輯',
        save: '儲存',
        service_duration: '服務時段',
        unknow_service_time: '未知',
        service_or_member_missing: '請先選服務/人員',
        overlapped_booking_confirm_title: '確定修改時間？',
        overlapped_booking_accept_confirm: '將與以下預約同時進行，您確定要接受預約嗎？ <br><br> {bookingInfo}',
        overlapped_booking_confirm: '這個時段將與以下預約同時進行，您確定要更改到這個時間嗎？ <br><br> {bookingInfo}',
        newly_saved_booking: '預約編號 {bookingDisplayId} 已儲存',
        confirm_creating_booking: '確認新增預約？',
        confirm_saving_booking: '確認儲存預約？',
        enter_booking_id_to_search: '輸入預約編號、顧客姓名或電話',
        enter_booking_id_to_search_mobile: '搜尋',
        member_doesnt_provider_this_service: '此人員沒有提供此服務',
        member_not_working_at_selected_datetime: '此時段非此人員上班時間',
        member_leave_or_booked_at_selected_datetime: '此時段此人員已有預約或請假',
        invalid_booking_content_explanaing: '目前訂單部分與通常設定不符合，請確認後再儲存。',
        cancel_booking: '取消預約',
        cancelled_at: "於 {cancelledAt} 取消",
        customer_cancelled_at: "顧客於 {cancelledAt} 取消",
        rejected_at: "於 {rejectedAt} 拒絕",
        add_booking: '新增後續服務',
        new_question: '新問題',
        end_datetime: '結束時間',
        edit_order: '編輯訂單'
    },
    information: {
        bio_link_integration: '多連結整合工具',
        transfer_bank_info: '轉帳收款銀行帳號',
        transfer_bank_info_placeholder: '用於接受顧客轉帳付款的銀行資訊，包含：銀行名稱、分行名、帳號以及戶名。',
        vat_number: '統一編號',
        business_entity_name: '營業人名稱',
        show_business_entity_info: '於主頁顯示統一編號及營業人資訊',
        receiver: '收件人',
        print_scale: '列印尺寸偏好',
        print_scale_s: '尺寸 - 小',
        print_scale_m: '尺寸 - 中',
        print_scale_l: '尺寸 - 大',
        old_landing_version: '傳統模式',
        landing_version_preview_forms: '新版預覽問卷模式',
        landing_version: '主頁模式',
        preview_landing_v2: '預覽新版模式',
        name: '公司名稱',
        phone: '電話',
        email: 'Email',
        company_address: '公司地址',
        contact_address: '聯絡地址',
        address: '地址',
        subdomain: '子網域名稱',
        line_id: 'LINE ID / LINE 網址',
        timezone: '時區',
        confirm: '確認',
        save: '儲存',
        name_placeholder: '公司名稱',
        custom_domain: '自訂網域',
        email_preference: '通知',
        email_preference_booking_status_change: '接收新預約/更改預約狀態/收到款項時的郵件通知',
        google_site_verification_code: 'Google 網站驗證碼',
        currency: '貨幣別',
        facebook_account: '粉絲專頁用戶名稱',
        twitter_account: 'X 帳號',
        instagram_account: 'Instagram 專頁',
        seo_title: '網站標題 (SEO)',
        seo_description: '網站簡述 (SEO)',
        seo_title_placeholder: '輸入網站標題，預設為公司名稱。',
        seo_description_placeholder: '輸入預約網站簡述，將顯示在搜尋網站結果內 。',
        seo_title_hint: '搜尋引擎（如 Google/Bing/Yahoo）會讀取網站標題作為搜尋排名用途，建議您將工作室或公司名稱以及您提供的服務精簡輸入在這裡。',
        seo_description_hint: '搜尋引擎在顯示結果時，會將您輸入的簡述顯示在結果頁面。吸引人的簡述內容較容易吸引您的顧客上門！',
        ask_order_member_first: '先選服務人員',
        ask_order_service_first: '先選服務',
        ask_order: '預約主頁詢問方式',
        login_module: '顧客登入',
        login_module_hint: '允許顧客透過手機號碼 / Facebook / LINE 帳號 登入',
        login_module_explanation: '開啟此功能，<b class="text-danger">必須儲值簡訊點數</b>進行顧客手機號碼驗證<br>若要開啟 Facebook 登入，請先點此<a href="/b/integration">整合 Facebook 粉絲頁</a>以及開啟顧客通知內的 <a href="/b/notification_setting?current_notification_type=facebook">Facebook Messenger 通知</a><br>若要開啟 LINE 登入，請先整合 LINE Login 服務',
        head_html: '自訂網頁標頭 HTML',
        head_html_placeholder: '填入欲插入在您主頁內的 HTML，可用於設定 Google 商家網站驗證或是 Google Analytics 追蹤。',
        landing_is_preparing: '網站設為準備中',
        ga_tracking_id: 'GA 追蹤 ID',
        ga_tracking_id_placeholder: '輸入 Google Analytics 追蹤 ID',
        show_line_customer_chat: '顯示於主頁',
        enable_login_without_sms_verification: '無法驗證仍可登入',
    },
    form: {
        form: '問卷',
        default_title: '預設問卷',
        create_new_form_option: '新增一份問卷',
        or_create_new_form_option: '...新增一份問卷',
        show_archived_form: '顯示已封存問卷',
        create_new_form: '新增問卷',
        duplicate_form: '複製問卷',
        create_new_form_hint: '有服務需要不同的問卷，只要新增問卷，並設定給服務即可讓顧客在預約不同服務時填寫。',
        create_new_form_placeholder: '問卷名稱（僅供您用來區分問卷）',
        update_form: '更新問卷',
        update_form_placeholder: '請輸入新的問卷名稱（僅供您用來區分問卷）',
        please_select_accepting_file_types: '請選擇要接受的檔案類型',
        file_type_image: '圖片（JPG/PNG）',
        file_type_pdf: 'PDF 文件',
        file_type: '檔案類型',
        max_file_count: '檔案上限',
        file_unit: '個檔案',
        select_file: '選擇檔案',
        click_to_enter_file_caption: '點此輸入檔案備註',
        too_many_files: '超過可上傳的檔案數量',
        please_select_file_to_upload: '請上傳檔案',
        max_n_files_suppoprted: '可選 {count} 個',
        n_selected_files_suppoprted: '已選 {count} 個',
        upload_accept_type_image: 'JPG/PNG 圖片',
        upload_accept_type_pdf: 'PDF 文件',
        sure_to_delete_form: '確定要刪除問卷？目前使用此問卷的服務將被設定為不使用問卷。',
        sure_to_duplicate_form: '以此問卷為基礎建立另外一份問卷？兩份問卷後續修改將不會互相影響。',
        duplicate_form_placeholder: '新問卷名稱',
        form_is_archived: "已封存問卷 {name}",
        form_is_unarchived: "已解除封存問卷 {name}",
        archived_forms: "已封存問卷",
        section: "區段 {count}",
    },
    bookingTable: {
        show_only_today_bookings: '只搜尋今日預約',
        booking_pass_used: '課卡使用',
        please_enter_contracted_customer_id: "請輸入契客代號",
        logistic_method: "物流方式",
        export_for_tcat: "匯出黑貓表單",
        export_for_ezprint: "匯出黑貓(EZPRINT)表單",
        print_all_limit_exceeds: '總筆數超過一次可列印筆數 {max} 筆，請縮小範圍',
        fetching_bookings: '正在取得預約資料',
        print_all: '列印全部',
        any_status: "所有狀態",
        payment_paid: "已收款",
        payment_has_pending: "未付款",
        payment_has_expired: "已逾期",
        payment_has_failed: "付款失敗",
        payment_has_cancelled: "已取消",
        logistic_shipped: "已出貨",
        logistic_pending: "待出貨",
        logistic: "物流",
        payment_condition: "款項",
        created_manually: "手動建單",
        auto_approved: '自動接受',
        sms_verified: '號碼已驗證',
        sms_not_verified: '號碼未驗證',
        notification_failure: '發送失敗',
        notification_sending: '發送中',
        notification_success: '成功',
        email_subject: '主旨',
        file_vault_is_enabled: '使用中',
        unapproved_booking: '新預約',
        approved_booking: '進行中預約',
        other_booking: '已過期/拒絕',
        paging_information_entry: '共 {total} 筆',
        paging_information_page: ' ({current}/{totalPage} 頁)',
        create_new_booking: '新增預約',
        no_note_yet: '尚無備註',
        note_content: '備註內容',
        check: '查看',
        customer_notification: '顧客通知',
        notification_log: '通知紀錄',
        sync: '同步',
        no_notification_log: '沒有紀錄',
        filter: '篩選',
        already_filtered: '已篩選',
        filter_condition: '篩選條件',
        clear_all_conditions: '清除所有條件',
        clear_condition: '清除條件',
        service_interval: '服務區間',
        start_hours: '開始時間',
        end_hours: '結束時間',
        service_content: '服務內容',
        booking_passes: '課卡',
        service_member: '服務人員',
        syncing_booking: '正在將預約紀錄送至 Google Calendar...',
        syncing_booking_done: '傳送完成',
        batch_accept_bookings: '接受預約',
        batch_reject_bookings: '拒絕預約',
        accept_ok: '預約接受',
        reject_ok: '預約拒絕',
        cancel_booking: '刪除',
        cancel_ok: '預約已取消',
        loading_bookings: '取得預約中...',
        file_vault: '檔案庫',
        customer_cancelled_bookings: '顧客取消',
        new_customer_cancelled: '新',
        sms_status_FAILED_SYSTEM: "發送失敗",
        sms_status_FAILED_SMS_PROVIDER: "發送失敗",
        sms_status_FAILED_INSUFFICIENT_CREDIT: "簡訊點數不足",
        sms_status_FAILED_BAD_PHONE_NUMBER: "號碼不正確 ",
        notification_type_sms: "簡訊",
        notification_type_email: "Email",
        notification_type_line: "LINE",
        full_message: "訊息內文",
        in_booking_group: "多重預約",
        export: "匯出",
        export_all: "匯出全部",
        sort_method: "排序方式",
        payments: "款項",
        send_mail_to_filtered_bookings: "發電子郵件給 {n} 個預約",
        send_sms_to_filtered_bookings: "發簡訊給 {n} 個預約",
        selected_member_hint: "已選 {names} 所提供的服務",
        line_status_error_400: "發送失敗",
        line_status_error_401: "發送失敗",
        line_status_error_403: "發送失敗",
        line_status_error_404: "發送失敗",
        line_status_error_409: "發送失敗",
        line_status_error_410: "發送失敗",
        line_status_error_413: "發送失敗",
        line_status_error_415: "發送失敗",
        line_status_error_429: "發送失敗",
        line_status_error_500: "發送失敗",
    },
    grade: {
        grade: '會員級別',
        level: '級別',
        create: '新增會員等級',
        please_input_grade_level: '請輸入會員等級'
    },
    grade_capability: {
        enabled: '開啟',
        max: '上限'
    },
    capability: {
        item: '項目',
        capability: '附加功能',
        title: '名稱',
        type: '種類',
        onoff: 'On/Off',
        maxcap: '上限',
        default: '預設值',
        create: '新增項目',
        please_input_capability_title: '請輸入英數 id',
        please_input_capability_display_label: '請輸入顯示名稱',
        please_pick_capability_type: '請選擇種類',
        please_input_capability_default: '請輸入預設值',
        profolio_count: '主頁作品集區塊數量上限',
        album_count_per_portfolio: '作品集內相簿數量上限',
        photo_count_per_album: '作品集相簿內照片數量上限',
        photo_compression: '作品集照片壓縮比(0 ~ 1)',
        email_module: '手動發信功能是否開啟',
        google_calendar: 'Google 日曆整合是否開啟',
        team_member_count: '團隊成員數量上限',
        member_points: '會員點數',
        email_price_per_exceeding: '超額 Email 每封價格',
        coupon_available_per_year: '每年可啟用優惠券數量',
        promocode_available_per_year: '每年可啟用優惠碼數量' 
    },
    errors: {
        error_occured: '發生錯誤',
        unknown: '未知的錯誤',
        service: {
            end_date_must_not_be_before_start_date: '限定期間的結束日期不可早於開始日期',
            no_working_day_ok_for_such_service_time_setting: '依成員目前設定的工作時間沒有人能提供這個服務！請確認是否開始時間太早、結束時間太晚或是卡到休息時間了。',
            update_fail: '無法更新服務'
        },
        api: {
            forbidden: {
                no_gcalendar_integration_yet: '無法把預約加入 Google Calendar，因為服務提供人員尚未設定 Google Calendar 整合哦！',
                cant_delete_last_admin: '不能刪除最後一位管理員'
            }
        },
        onboard: {
            subdomain_not_available: '已無法使用這個網址了',
            please_enter_service_title: '請輸入服務名稱',
            please_enter_service_duration: '請設定服務總長',
            subdomain_allows_alphadigits_only: '網域只能輸入小寫英文與數字哦！'
        }
    },
    members: {
        create: '新增人員',
        detail: '人員詳細',
        name: '人員名稱',
        email: 'E-Mail',
        role: '人員角色',
        phone: '電話',
        short_id: '人員簡稱',
        color: '辨識色彩',
        name_placeholder: '點此輸入服務人員名稱',
        email_placeholder: '點此輸入電子郵件地址',
        phone_placeholder: '點此輸入電話',
        short_id_placeholder: '點此輸入辨識簡稱(兩碼)',
        role_placeholder: '點此選擇人員角色',
        working_times: '人員工作時間',
        apply_provider_working_time: '套用營業時間',
        member_saved: '人員資料已儲存',
        confirm_delete_member: '確定要刪除此人員？',
        delete_member: '刪除人員',
        deleted: '已刪除',
        restore_member: '恢復人員',
        confirm_restore_member: '確定要恢復此人員？',
        add_member: '增加新成員',
        placeholder_name: '成員名字',
        placeholder_content: '簡介',
        validation: {
            name_empty: '請輸入成員名字',
            email_empty: '請輸入成員 Email',
            short_id_empty: '請輸入成員辨識簡稱',
            role_not_selected: '請選擇成員角色'
        },
        is_internal: "設為內部人員",
        is_internal_hint: "顧客不會在主頁人員列表看到內部人員。",
        verification_mail_is_sent_to_new_member_email: '一封邀請信已發送至成員 Email 信箱 {email}。請成員打開該信件進入系統。'
    },
    provider_role: {
        admin: '管理員',
        member: '一般使用者'
    },
    onboard: {
        previous: '上一步',
        next: '下一步',
        welcome: {
            title: 'Welcome',
            text: '準備好打造自己的預約系統了嗎？',
            ready: '準備好了'
        },
        subdomain: {
            title: '專屬網址',
            text: '您可以輸入一組獨一無二的公司網址',
            hint: '英文或數字'
        },
        workingTime: {
            title: '營業時間',
            text: '可以在左側<span class="highlighted">基本資訊</span>裡設定<br>可供預約之工作室營業時間表<br>目前我們已為您預設一組營業時間（週一至週五 9-17 點）'
        },
        services: {
            title: '服務項目',
            text: '可以在左側<span class="highlighted">服務項目</span>裡設定<br>可供預約之各項服務內容，現在就新增一筆！'
        },
        members: {
            title: '服務人員',
            text: '可以在左側<span class="highlighted">服務人員</span>裡設定<br>可提供預約的服務人員<br>目前我們已預設您為其中之服務人員'
        },
        finish: {
            title: '打造完成',
            text: '一個專屬於<a class="highlighted" href="{link}" target="_blank">您的預約系統</a>誕生了！<br>設定更多前，先讓顧客第一時間發現您的預約系統吧！',
            start: '進入後台'
        }
    },
    plan: {
        upgrade_now: '立即升級',
        offer_management: '優惠管理',
        customer_login: '會員登入',
        shopping_bag_module: '購物模組',
        by_using_our_service_you_are_accepting_our_terms_and_privacy_policy: '我同意並將遵守 Ding 訂管家的<a target="_blank" href="https://dingup.cc/terms">使用條款</a>以及<a target="_blank" href="https://dingup.cc/privacy">隱私權政策</a>',
        invoice_email: "電子發票收取信箱",
        invoice_donation_code: "發票捐贈愛心碼",
        default_88888_hint: "預設 88888 愛心碼為捐贈至「中華民國兒童癌症基金會」",
        basic: '蜂鳥',
        standard: '海鸚',
        premium: '天鵝',
        upgrade_needed: '立即升級以使用此功能',
        upgrade: '立即升級',
        upgrade_reason_team_full: '依據目前您的方案，您可以有 {teamMemberCount} 位團隊成員。升級您的方案來加入更多新成員吧！',
        month: '月',
        annually_pay_savings: '年付可省下 {currency} {saving}',
        team_member_cap: '團隊成員數量上限',
        portfolio_number: '作品集數量',
        portfolio_number_content: '{album} 本 x {photo_per_album} 張相片',
        compression: '照片壓縮比',
        auto_notification: '信件通知',
        auto_notification_with_manual: '信件通知<br>（可手動發信）',
        reservation_form: '預約問卷',
        booking_management: '預約管理',
        customer_management: '顧客管理',
        photo_quality: '照片品質',
        high_photo_quality: '4K/高品質輕度壓縮',
        medium_photo_quality: '1080P/一般壓縮',
        unlimited: "無限",
        email_management: "手動發信功能",
        google_calendar_integration: "Google 行事曆整合",
        team_calendar_management: "團隊行事曆管理",
        email_management_tips: "可使用發信功能與顧客聯繫，包括儲存信件內容範本，輕鬆寄出您的範本郵件",
        upgrade_now: "立即升級",
        please_choose_duration: "選擇訂閱方案",
        becoming_membership_of: "成為 {planTitle} 會員",
        season: '三個月訂閱',
        'half-year': '半年訂閱',
        year: '一年訂閱',
        months: '個月',
        ready_to_subscribe: '確定訂閱',
        subscription_item: '訂閱項目',
        summary_period: '訂閱期間',
        summary_price: '價格',
        summary_coupon_applied: '優惠券',
        summary_subtotal: '總計',
        membership: '會員',
        payment_summary: '完成付款細節',
        payment_atm: '自行轉帳',
        payment_credit: '信用卡',
        payment_method: '付款方式',
        invoice_information: '發票資訊',
        invoice_title: '發票買受人',
        invoice_sending: '發票寄送',
        invoice_type_no: '捐贈發票',
        invoice_type_2_copies: '二聯式發票',
        invoice_type_3_copies: '三聯式發票',
        invoice_company_tax_id: '公司統一編號',
        invoice_recipient: '收件人姓名',
        invoice_phone: '聯絡電話',
        invoice_address: '寄送地址',
        invoice_pref_city: '城市',
        invoice_pref_area: '區域',
        invoice_pref_zip: '郵遞區號',
        invoice_pref_address: '地址',
        is_current_plan: '目前方案',
        contact_us: '聯絡我們',
        to: '至',
        renew_now: '馬上續約',
        current_membership_type: '目前會籍為 {level} 會員',
        regrade_current_membership_type: '目前會籍為 <b>{level} 會員</b>',
        upgrade_to_use_this_function: '立即升級以使用此功能',
        atm_date_adjust_hint: '注意：訂閱開始與結束日期將依轉帳繳款日期對應調整。',
        coming_soon: '即將推出',
        e_contract: '電子合約管理 ',
        fb_integration: 'Facebook 訊息串接',
        embed_button: '外嵌預約按鈕',
        more_feature_on_the_way: '...更多功能擴充中',
        embed_button_tips: '您可將預約按鈕置放在您既有的網站中，顧客可以直接在您的官網進行預約。',
        fb_integration_tips: '整合 Facebook，系統將視情況引導顧客至預約系統進行預約。此外，DING 訂管家也可以透過 Facebook 訊息通知顧客預約狀態。',
        customer_booking_reminder: '一天前預約提醒',
        customize_customer_booking_reminder: '自訂預約提醒時間',
        file_vault: "與顧客共享檔案庫",
        file_vault_content: "{maxSize}/保留 {retentionMonth} 個月",
        file_vault_tip: "將與顧客共用的設計/文件/圖片等檔案集中管理，便於查詢與歸檔。檔案保留時間由預約結束後開始計算。",
        customer_points: '會員點數',
        coupon_available_yearly: '每年 {maxCap} 組優惠券',
        promocode_available_yearly: '每年 {maxCap} 組優惠碼',
        email_module: '手動發信',
        private_service: '私密賣場',
        fb_customer_chat: 'Facebook 聊天泡泡',
        line_login_integration: 'Line 登入整合',
        payment_integration: '線上金流整合',
        payment_integration_content: 'TapPay、綠界 ECPay、LINE Pay',
        landing_page: '一頁式官網',
        black_list: '黑名單管理',
        sms_module: '簡訊通知',
        line_module: 'LINE 通知',
        interstitial: '蓋板公告',
        coupon_management: '優惠券管理',
        promocode_management: '優惠碼管理',
        email_cap_hint_basic: '免費 1000 封/月<small><br>超額每封 0.05/元</small><br><small>自 2024/03/01 生效</small>',
        email_cap_hint_standard: '免費 2000 封/月<small><br>超額每封 0.05/元</small><br><small>自 2024/03/01 生效</small>',
        email_cap_hint_premium: '免費 3000 封/月<small><br>超額每封 0.05/元</small><br><small>自 2024/03/01 生效</small>',
    },
    contract: {
        save_template: '儲存樣板',
        filter_options_placeholder: '輸入關鍵字搜尋合約樣板',
        contract: '合約',
        create_new_contract_option: '...建立一個合約樣板',
        create_new_contract_template: '建立新合約樣板',
        create_new_contract_template_hint: '設定不同的合約樣板，提供給不同需求的顧客簽署。',
        create_new_contract_template_placeholder: '合約樣板名稱 （僅供您用來區分合約樣板）',
        you_dont_have_any_contracts_yet: '您還沒有任何合約樣板。',
        create_first: '建立第一個樣板',
        editor_placeholder: '開始輸入您的合約樣板',
        placeholder_customer_name: '顧客姓名',
        placeholder_customer_phone: '顧客電話',
        placeholder_customer_email: '顧客 Email',
        placeholder_booking_start_datetime: '服務開始時間',
        placeholder_booking_end_datetime: '服務結束時間',
        placeholder_booking_service_title: '服務名稱',
        placeholder_provider_name: '公司/工作室名稱',
        placeholder_provider_address: '公司/工作室地址',
        placeholder_provider_phone: '公司/工作室電話',
        placeholder_staff_name: '服務成員名字',
        template_saved: '合約樣板成功儲存',
        template_deleted: '合約樣板已刪除',
        changes_not_saved_sure_to_switch_to_another_contract: '還有尚未儲存的修改！確定要切換到其他合約樣板嗎？',
        switch: '切換',
        contract_template: '合約樣板',
        e_signing: '電子簽章',
        e_signing_explanation: '事先上傳電子簽章（JPG/PNG）將自動附加在產生的合約最底部。',
        no_e_signing_yet: '您還沒有上傳電子簽章圖檔',
        upload_e_signing: '上傳電子簽章',
        management: '合約管理',
        create_new_contract: '建立新版本',
        template_not_selected: '未使用樣板',
        select_template_if_needed: '選擇樣板直接生成合約',
        dont_use_template: '不使用樣板',
        status_initiating: '擬稿中',
        status_pending: '等候簽署',
        status_signed: '顧客已確認',
        status_outdated: '已無效',
        loading_contracts: '讀取中...',
        contract_editor_placeholder: '直接輸入合約內容，或套用合約樣板快速產生合約',
        contract_content_will_be_reset_after_switch: '將依照新選取的樣板重新產生合約內容，確定嗎？',
        preview: '預覽',
        send_to_customer: '發送給顧客簽署',
        last_sent_at: '合約於 {lastSentAt} 送出',
        signed_at: '合約簽署於 {signedAt} ',
        save: '暫存',
        contract_has_been_sent_for_signing: '已送出合約等候顧客簽署',
        hint_for_creating_contract: '您目前沒有任何合約樣板，您可以前往 <a href="/b/contracts">合約樣板</a> 新增合約樣板，輕鬆產生合約給顧客喔！',
        update_name: '更名',
        update_contract_template: '更新合約樣板',
        update_contract_template_placeholder: '請輸入新的合約樣板名稱',
        your_e_signing_is_saved: '電子簽章成功儲存',
        please_enter_content: '請輸入內容',
        sure_to_create_new_contract: '確定要建立新合約？<br>若有先前的合約將作廢，顧客將無法瀏覽或同意該合約。 ',
        contract_saved: '合約已儲存',
        browser_not_support_pdf_embeded: '您的瀏覽器不支援檢視內嵌 PDF 合約檔案。',
        open_contract_pdf_directly: '點此直接打開',
        no_contracts_yet: '無任何合約'
    },
    customer_booking_checker: {
        check_booking: '查詢預約',
        enter_your_booking_id: '請輸入您的預約編號',
        query: '查詢',
        no_booking_found: '無此預約資料',
        booking_status_approved: '已接受您的預約',
        booking_status_unapproved: '尚未確認您的預約，請等候通知',
        booking_status_rejected: '此預約不成立',
        booking_status_cancelled: '此預約已經取消',
        booking_status_customer_cancelled: '此預約已被顧客取消',
        expired: '已逾期',
        sure_to_cancel_booking: '確定要取消預約？',
        sure_to_cancel_booking_with_presets: '課卡包含的預約將一併取消。<br>確定要取消預約？',
        cancel_booking: '取消預約',
        default_no_cancellation: '此預約不可透過網路取消，請直接聯繫我們，謝謝。',
        default_no_cancellation_anytime_pass_start_datetime: '已超過服務開始時間，無法取消。',
        default_no_cancellation_anytime_pass_end_datetime: '已超過服務結束時間，無法取消。',
        booking_cancelled: '預約已取消',
        reason: '原因：',
        contract_already_signed: '您已有合約簽署，不可透過網路取消，請直接聯繫我們，謝謝',
        booking_pass_cannot_cancel: '此為課卡自動預約，無法取消。'
    },
    month_f: {
        '1': '1月',
        '2': '2月',
        '3': '3月',
        '4': '4月',
        5: '5月',
        6: '6月',
        7: '7月',
        8: '8月',
        9: '9月',
        10: '10月',
        11: '11月',
        12: '12月',
    },
    month: {
        '1m': '1月',
        '2m': '2月',
        '3m': '3月',
        '4m': '4月',
        '5m': '5月',
        '6m': '6月',
        '7m': '7月',
        '8m': '8月',
        '9m': '9月',
        '10m': '10月',
        '11m': '11月',
        '12m': '12月',
    },
    dashboard: {
        monthly_booking_on_services: '服務預約狀況',
        monthly_booking_on_members: '人員預約狀況',
        booking: '提供服務',
        booking_request: '新詢問',
        visits: '主頁瀏覽量',
        bookings_today: '本日預約',
        no_bookings_yet: '尚無預約',
        period: {
            'week': '本週',
            'month': '月',
            'year': '年'
        },
        view_all_in_schedule: '查看行事曆 ',
        n_more_bookings: '還有 {count} 個預約',
        upcoming_bookings: '近期預約',
        number_of_bookings: '數量'
    },
    file_vault: {
        invite_customer: '分享',
        invite_customer_method_1_share_url: '複製下面網址並提供給顧客',
        file_vault_title: '預約檔案庫',
        this_folder_is_empty: '目前未有任何檔案',
        root: '檔案庫 ',
        upload_file: '上傳檔案',
        uploader_type_customer: '顧客',
        file_name: '名稱',
        file_size: '大小',
        uploaded_by: '上傳者',
        uploaded_at: '上傳時間',
        file_type: '類型',
        new_folder: '新資料夾',
        enter_folder_name: '請輸入資料夾名稱',
        path_back: '〈 返回',
        type_folder: '資料夾',
        grid: '格狀',
        list: '列表',
        are_you_sure_to_delete: '確定要刪除 {fileName} 嗎？',
        url_copied: '已複製檔案庫連結',
        invite_customer_method_2_email_url: '已通知方式發送檔案庫網址給顧客',
        invite_customer_hint: '輸入要一併給顧客的訊息，譬如您希望顧客提供的檔案內容、類型...等。',
        default_content: '預設內容：',
        invite_customer_message_default: '因為您以下的預約，您已被邀請至檔案庫分享檔案。點擊下方連結開始瀏覽或分享檔案。',
        send_invitation: '發送邀請',
        copy_link: '複製網址',
        invitation_sent: '已發出邀請',
        fail_to_send_invitation: '錯誤，無法發出邀請 ',
        this_vault_is_cleared_at: '此檔案庫已超過保留期限，已無法瀏覽與上傳檔案。',
        retention_hint: '檔案庫內檔案為您保存至預約結束時間後 {n} 個月',
        file_vault_usage_hint: '您與顧客均可在此上傳任何形式之檔案，增進彼此的溝通。',
        rename_file: '重新命名',
        rename_hint: '',
        enter_new_name: '請輸入新的檔案名稱',
        this_vault_size_used: '檔案庫空間 ',
        new_file: '新增',
        fail_to_get_file_vault: '無法取得檔案庫內容'
    },
    sms: {
        compose: '編輯簡訊內容',
        template_title: '範本名稱',
        apply_template: '套用範本',
        to: '收件人',
        body: '內文',
        send: '寄出',
        choose_from_template: '選擇範本',
        compose_template: '編輯範本',
        no_templates_yet: '還沒有範本',
        fail_to_send_sms: '發送失敗...',
        fail_to_send_sms_for_bookings: '以下預約發送失敗：\n {bookings}',
        template_saved: '已儲存範本',
        mail_sent: '通知已寄出囉',
        not_sent_successfully: '發送失敗',
        fail_to_send_insufficient_credit: '您的點數不足，無法發送',
        fail_to_update_sms_template: '無法更新簡訊樣板',
        fail_to_create_sms_template: '無法新增簡訊樣板',
        save_edited_template: '儲存修改',
        save_as_template: '儲存為新範本',
        template_delete: '刪除範本 {templateName} 嗎？',
        enter_template_name: '範本名稱',
        current_char_count: '共 {n} 字，',
        current_credit_required: '需簡訊點數 {nCredit} 點',
        message_too_long: '共 {n} 字，訊息超過上限 333 字，無法發送',
        sms_sending: '簡訊發送中',
        template_title_hint: '範本名稱',
        system_error: "系統錯誤，請稍候再試。若持續出現此錯誤，請聯絡 DING 訂管家。",
        fail_to_receive_message: "若您持續無法收到驗證簡訊，請參考以下方式排除：<br><br><ol><li>請確認手機收訊正常且未開啟飛航模式</li><li>請確認手機內是否有安裝廣告阻擋App 或網路安全軟體，這些軟體可能將系統簡訊號碼設為黑名單</li><li>請確認手機容量是否到達上限</li><li>請向您的電信商確認您是否有申請「阻擋企業簡訊廣告」，若有申請此功能，系統間訊號碼也會被設成黑名單導致無法收到簡訊</li><li>請確認您輸入的手機號碼正確</li><li>請確認手機簡訊 App 是否有異常</li></ol><hr>若您確認過上述項目，仍無法收到簡訊，請與我們聯絡進行預約，謝謝您。",
        url_shorten_message: '(此字數為系統稍後將網址縮短後計算的字數)',
        continue_without_sms_verification: '您將可以繼續完成預約，系統將標記您未完成電話號碼驗證。',
    },
    mitake: {
        status_0: '預約傳送中',
        status_1: '已送達業者',
        status_2: '已送達業者',
        status_4: '已送達手機',
        status_5: '內容有錯誤',
        status_6: '門號有錯誤',
        status_7: '顧客門號拒收企業簡訊',
        status_8: '逾時無送達',
        status_9: '預約已取消'
    },
    ev8d: {
        status_0: '發送中',
        status_100: '已送出',
        status_101: '⼿機關機/訊號不良/簡訊功能異常',
        status_102: '網路系統/基地台設備異常',
        status_103: '⼿機⾨號為空號或停⽤中',
        status_104: '手機門號為電信黑名單或有設定擋簡訊廣告',
        status_105: '⼿機設備問題/⼿機出現未預期錯誤',
        status_106: '電信商系統傳送時發⽣非預期錯誤',
        status_107: '⼿機關機/訊號不良/簡訊功能異常',
        status_300: '預約簡訊',
        status_303: '取消預約',
        status_500: '不支援國際簡訊',
        status_501: '門號無法發送 WAP',
        'status_-1': '錯誤 -1',
        'status_-2': '錯誤 -2',
        'status_-3': '錯誤 -3',
        'status_-4': '錯誤 -4',
        'status_-5': '錯誤 -5',
        'status_-6': '錯誤 -6'
    },
    country: {
        taiwan: '台灣',
        hongkong: '香港'
    },
    payments: {
        pending_item: "待付款 - {method} ${amount}",
        paid_item: "已收款 ${amount}",
        expired_item: "逾期 ${amount}",
        cancelled_item: "已取消 ${amount}",
        failed_item: "付款失敗 ${amount}",
        payment: '款項',
        no_payments_yet: '尚無款項',
        "status_PAID": "已收款",
        "status_PENDING": "待付款",
        "status_EXPIRED": "逾期",
        "status_FAILED": "付款失敗",
        "status_CANCELLED": "付款已取消",
        pending_summary: '未付款 ${sum}',
        paid_summary: '已收款 ${sum}',
        expired_summary: '已逾期 ${sum}',
        cancelled_summary: '已取消 ${sum}',
        collected_at: '${amount} 於 {collected_at} 收款'
    },
    item: {
        should_count_for_free_logistic_rule: '數量計入免運規則計算',
        all: '所有',
        renting_charge_type_per_booking: '每次',
        renting_charge_type_per_day: '每天',
        renting_charge_amount_placeholder: '收費金額',
        renting_charge_type_per_night: '每晚',
        renting_charge_type_per_hour: '每小時',
        renting_charge_type: '收費',
        default_renting_return_time_hint: '設定此時間表示本商品在預約結束當日的此時間後就可以再被租借，不需等到預約結束時間到。',
        set_custom_return_time: '指定歸還時間',
        show_stock_info: '商品顯示剩餘數量',
        default_renting_return_time: '歸還於',
        is_for_renting: '租借型商品',
        is_for_renting_hint: '租借型商品，在預約結束日的歸還時間（如下設定）到的時候，可租借數量會回補。系統將自動協助顧客判斷預約時段是否還可以租借此商品。',
        n_left: '(剩餘 {n})',
        price: '價格',
        original_price: '原價',
        category: "類別",
        title: "商品名稱",
        stock: "庫存數量",
        no_category: "未歸類",
        status: "狀態",
        visible: "上架中",
        hidden: "已下架",
        spec_title: "規格名",
        min_per_order: "最少購買量",
        max_per_order: "最大購買量",
        min_per_order_n: "最少買 {n} 個",
        max_per_order_n: "最多買 {n} 個",
        max_per_day: "每日總量",
        max_per_day_n: "每日總量 {n}",
        total_count: "總量",
        total_count_per_day: '每日總量',
        image: '圖片',
        logistics: '物流方式',
        renting_charge: "${amount}/{unit}",
        renting_charge_unit_BOOKING: '次',
        renting_charge_unit_DAY: '天',
        renting_charge_unit_NIGHT: '晚',
        renting_charge_unit_HOUR: '小時',
        fixed_date_time: '固定提供時間',
        points_deductable: '可用點數折抵',
        auto_hidden_when_expired: '超過期限自動下架',
	},
	orders: {
		booking_order_items: '購買項目',
		no_booking_order_items: '無購買項目',
        logistics: '物流',
	},
    logistics: {
        type_HOME_DELIVERY: "宅配",
        type_FREE_OR_SELF_TAKEN: "顧客自取",
        type_BOOK_DELIVERY: "預約送件",
        area_TAIWAN: "台灣本島",
        area_OFF_ISLAND: "離島",
        area_NONE: "不需運送",
        logistic_FIXED: "單一費率",
        logistic_BY_AMOUNT: "按金額收費",
        logistic_BY_COUNT: "按件數收費",
        logistic_BY_WEIGHT: "按重量收費",
        payment_type_PAYMENT_GATEWAY: "系統串接付款",
        payment_type_MANUAL: "貨到付款（店家自行請外部物流商代收款項)",
        condition_NORMAL: "常溫",
        condition_COLD: "冷藏",
        condition_FROZEN: "冷凍",
        rule_FIXED: "固定費率",
        rule_BY_WEIGHT: "按重量收費",
        rule_BY_AMOUNT: "按金額收費",
        rule_BY_COUNT: "按件數收費",
        rule_title_FIXED: "運費金額",
        rule_title_BY_WEIGHT: "訂單重量",
        rule_title_BY_AMOUNT: "訂單金額",
        rule_title_BY_COUNT: "訂單商品數",
        status_pending: "待出貨",
        status_shipped: "已出貨",
        status_delivered: "已送達",
        shipped_at: "已出貨於 {shippedAt}",
        trade_no: "物流單號",
        free_shipping_for_order_amount: "滿 {amount} 免運",
        free_shipping_for_count: "滿 {count} 件免運",
    },
    offers: {
        type_PROMO_CODE: '優惠碼',
        type_COUPON: '優惠券',
        rule_FIXED_AMOUNT: '固定金額',
        rule_PERCENTAGE: '折扣百分比',
    },
    gateway: {
        "ecpay": "綠界ECPay",
        "linepay": "LINE Pay",
        "tappay": "TapPay",
        "manual": "到店付款",
        "atm": "自行轉帳",
        "atm_info": "轉帳付款資訊"
    },
    sold_out: '售完',
    tcat: {
        unset: '不選特定黑貓運送尺寸',
        size_1: '黑貓 60cm',
        size_2: '黑貓 90cm',
        size_3: '黑貓 120cm',
        size_4: '黑貓 150cm',
    },
    tcat_size: '黑貓尺寸',
    tcat_size_select_hint: '黑貓配送尺寸',
    customer_points: {
        login_module_is_required_for_member_points: "請先打開「顧客登入」功能，顧客才能登入查看剩餘點數或在預約/購買時使用點數！",
        go_set: "前往開啟"
    },
    campaigns: {
        target_ALL_LEVELS: '所有會員',
        target_SPECIFIED_LEVELS: '特定會員等級',
        rule_FIXED_AMOUNT: '固定金額',
        rule_PERCENTAGE: '折扣百分比',
        campaigns: '優惠活動',
    },
    youtube_form: {
        add_new_video: "新增 Youtube 影片",
        please_enter_youtube_video_link: "請輸入 Youtube 影片連結",
        please_enter_valid_youtube_url: "無法識別您輸入的影片連結",
        enter_description: "輸入影片說明，非必填"
    },
    customer_notifications: {
        booking_related: '預約相關',
        payment_related: '金流相關',
        logistic_related: '物流相關',
        contract_signing: '合約簽署',
        membership_related: '會員相關',
        others: '其他系統功能',
        booking_request: '送出預約要求',
        booking_accepted: '預約接受',
        booking_rejected: '預約被拒絕',
        booking_canceled: '預約被取消',
        booking_canceled_by_customer: '預約由顧客取消',
        unpaid_booking_order_reminder: '有購物之預約未付款提醒',
        booking_reminder: '預約前提醒',
        booking_survey_request: '預約問卷調查',
        payment_request: '要求付款',
        payment_paid: '通知收到付款',
        payment_canceled: '通知顧客取消付款',
        payment_expire_reminder: '逾期前提醒',
        order_shipped: '出貨通知',
        contract_signing_request: '要求合約簽署',
        contract_signed: '合約已簽回',
        coupon_sent: '發送優惠券',
        member_points_sent: '發送會員點數',
        customer_level_changed: '會員等級變更通知',
        customer_level_renewed: '會員等級續會通知',
        customer_level_expire_reminder: '會員等級到期前',
        file_vault_invitation: '檔案庫分享',
    },
    booking_passes: {
        related_passes: '相關課卡',
        preset_count_exceeds_number_of_redeem: '預設自動預約數量超過課卡可預約次數',
        available_passes: '可用課卡',
        buy_pass: '購買課卡',
        booking_to_activate_when_purchased: '購買後將自動預約以下項目',
        preset_service_and_member_user_required: '需設定預設服務與成員才能新增更多預約項目',
        preset_start_datetime_required: '需設定自動預約項目的開始時間',
        preset_service_required: '需設定自動預約項目的服務',
        preset_member_user_required: '需設定自動預約項目的成員',
        no_item_spec_selected_yet: '未選取商品/規格',
        confirm_presets_before_booking: '<hr>您同時購買了課卡 {bookingPassTitle}，將同時預約 {serviceTitle} 於以下時間 {datetimes}。',
        sold_out: '售完',
        no_bookings: '沒有預約',
        service: "預約內容",
        status: "狀態",
    },
    customer_table: {
        customer_list: '顧客列表',
        no_customers_yet: '尚無顧客',
        name: '姓名',
        level: '會員等級',
        contact: '聯絡方式',
        tags: '標籤',
        note: '備註',
        actions: '操作',
    },
    blocked_customers: {
        permanently_blocked: '黑名單至永久有效',
        customer_blocked_until: '黑名單至 {datetime}',
    },
    item_inline_price_editor: {
        n_specs_detail_hidden: '包含 {n} 項規格',
    },
    binding_information: {
        unbind: '解除綁定',
    },
    rich_editor: {
        bold: '粗體',
        italic: '斜體',
        underline: '底線',
        align_left: '靠左對齊',
        align_center: '置中對齊',
        align_right: '靠右對齊',
        align_justify: '左右對齊',
        text_alignments: '文字對齊',
        font_size: '字級大小',
        font_family: '字型',
        system_font_family: '系統字型',
        default_font_size: '預設字級大小',
        font_color: '字型顏色',
        background_color: '背景顏色',
    },
    link_editor: {
        title: '插入連結',
        url: '網址',
        open_as: '開啟連結於...',
        new_tab: '新分頁',
        current_tab: '目前分頁',
        text: '連結文字',
    },
}
